import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "tooltip-container",
    ref: "target",
    onMouseover: _cache[0] || (_cache[0] = (...args) => $options.show && $options.show(...args)),
    onMouseleave: _cache[1] || (_cache[1] = (...args) => $options.hide && $options.hide(...args))
  }, [_renderSlot(_ctx.$slots, "default"), (_openBlock(), _createBlock(_Teleport, {
    to: "body"
  }, [$data.showTooltip ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    ref: "tooltip",
    class: _normalizeClass(["tooltip py-2 px-4 text-[0.8rem] max-w-[50vw] rounded-xl", $data.position])
  }, _toDisplayString($props.text), 3)) : _createCommentVNode("", true)])), _createElementVNode("span", {
    ref: "hiddenText",
    class: "hidden-text"
  }, _toDisplayString($props.text), 513)], 544);
}